import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useLocationCtx } from "@/context/LocationContext";
import Layout from "@/components/Layout";
import Header from "@/components/Header";
import PromoCard from "@/components/PromoCard";
import { Spinner, EmptyState } from "@/components/States";

export default function OffersPage() {
  const { loc } = useLocationCtx();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    const params = { has_discount: true };
    if (loc.state) params.state = loc.state;
    if (loc.city) params.city = loc.city;
    api
      .get("/businesses", { params })
      .then((r) => setItems(r.data))
      .finally(() => setLoading(false));
  }, [loc.state, loc.city]);

  return (
    <Layout>
      <Header subtitle="Descuentos y promociones" />
      <section className="px-5 pt-4">
        <h2 className="font-display text-3xl font-black tracking-tighter">
          Ofertas <span className="text-[#E54D2E]">calientes</span> 🔥
        </h2>
        <p className="mt-1 text-sm text-[#5C5C5C]">Promociones exclusivas de la app.</p>
      </section>

      {loading ? (
        <Spinner />
      ) : items.length === 0 ? (
        <EmptyState title="No hay ofertas disponibles" subtitle="Vuelve pronto para nuevas promociones." />
      ) : (
        <section className="grid grid-cols-1 gap-4 px-5 pt-5">
          {items.map((b, i) => (
            <PromoCard key={b.id} business={b} index={i} full />
          ))}
        </section>
      )}
    </Layout>
  );
}
